import {configureStore} from '@reduxjs/toolkit'

import account from '~/reducers/account'
import global from '~/reducers/global'
import recharge from '~/reducers/recharge'

export const createStore = (state?) =>
  configureStore({
    reducer: {
      account,
      global,
      recharge,
    },
    preloadedState: state,
  })
// @ts-ignore
export type StoreType = ReturnType<typeof createStore>

export type RootState = ReturnType<StoreType['getState']>
export type AppDispatch = StoreType['dispatch']
